// src/hooks/useLanguageDetector.js
import { useState, useEffect } from 'react';

// 国家代码到语言的映射
const COUNTRY_LANGUAGE_MAP = {
  // 东亚地区
  CN: 'zh',
  HK: 'zh',
  TW: 'zh',
  JP: 'ja',
  KR: 'ko',

  // 英语国家
  US: 'en',
  GB: 'en',
  AU: 'en',
  CA: 'en',
  NZ: 'en',

  // 欧洲国家
  ES: 'es',
  FR: 'fr',
  DE: 'de',
  IT: 'it',
  PT: 'pt',
  RU: 'ru',

  // 默认
  DEFAULT: 'en'
};

const useLanguageDetector = () => {
  const [detectedLanguage, setDetectedLanguage] = useState(null);

  useEffect(() => {
    const detectLanguage = async () => {
      try {
        const browserLang = navigator.language.split('-')[0];
        if (['en', 'ja', 'zh', 'ko', 'es', 'fr', 'de', 'it', 'pt', 'ru'].includes(browserLang)) {
          setDetectedLanguage(browserLang);
          return;
        }

        // TODO: Get the language based on Ip
        setDetectedLanguage(COUNTRY_LANGUAGE_MAP.DEFAULT);

      } catch (error) {
        console.error('Error detecting language:', error);
        setDetectedLanguage(COUNTRY_LANGUAGE_MAP.DEFAULT);
      }
    };

    detectLanguage();
  }, []);

  return detectedLanguage;
};

export default useLanguageDetector;